import axios from 'axios';


function getXmlFile(url, callbackSuccess, callbackError) {
    axios.get(url)
    .then(response => {
        callbackSuccess(response);
    })
    .catch(error => {
        callbackError(error);
    });
}

export { getXmlFile };